import { useTranslation } from '@/lib/i18n';
import { StatusBadge } from '@/components/ui';
import type { ArtistTypeEnum } from '@/lib/api-admin/types';

export interface ArtistTypeBadgeProps {
  type: ArtistTypeEnum;
}

export const ArtistTypeBadge = ({ type }: ArtistTypeBadgeProps) => {
  const { t } = useTranslation('artists');
  return (
    <StatusBadge
      data-testid="artist-type-badge"
      data-type={type}
      size="sm"
      variant={type === 'GROUP' ? 'info' : 'neutral'}
      label={t(`artists.type.${type}`)}
    />
  );
};
